export const sentryTags = {
  TEMPLATES: 'templates',
  OLD: 'oldSites',
  OLD_WITH_NEW_COMPONENT_COLORS: 'oldSitesNewColorInComponents',
  HEAVY: 'heavy',
};
